import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { IDocument, Idocument_DIrectmsg, IDocument_locname } from 'src/app/models/IDocument';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { directDocAttachment, directmessageDTO } from 'src/app/models/IPharmacyDirectory';
import { DocumentService } from 'src/app/Services/Documents/document.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import htmltopdf from 'html-to-pdfmake'
import { ManageCatgoriesComponent } from 'src/app/AdminModule/AdminConfiguration/manage-catgories/manage-catgories.component';
import { ToastrService } from 'ngx-toastr';
import { SearchPatientDMPopupComponent } from 'src/app/search-patient-dmpopup/search-patient-dmpopup.component';
import { configuration } from 'src/environments/environment';

export interface DialogData {
  url: any;
  attachedObj: directDocAttachment;
  directMsgObj: directmessageDTO;
  ispreview: number;
}

@Component({
  selector: 'app-surescripts-clinical-direct-message',
  templateUrl: './surescripts-clinical-direct-message.component.html',
  styleUrls: ['./surescripts-clinical-direct-message.component.css']
})
export class SurescriptsClinicalDirectMessageComponent implements OnInit {
  DirectMessageForm: FormGroup;
  docUrl: any;
  patName: string = ""
  patDOB: string = ""
  patId: string = "";
  isPreview: boolean = false;
  isXMLPreview: boolean = false;
  isDailogPreview: boolean = false;
  xmlContent: any = "";
  constructor(public dialogRef: MatDialogRef<SurescriptsClinicalDirectMessageComponent>,
    private toastr: ToastrService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dmObj: DialogData,
    private docService: DocumentService,
    private fb: FormBuilder,
    private schedulerservice: SchedularServiceService
    , private sanitizer: DomSanitizer) {
    if (dmObj.directMsgObj.lastName)
      this.patName = dmObj.directMsgObj.lastName + " " + dmObj.directMsgObj.firstName

    this.patDOB = dmObj.directMsgObj.dob
    this.patId = dmObj.directMsgObj.patId;
    if (dmObj.ispreview == 3)
      this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl(configuration.msgAttachmentUrl + dmObj.attachedObj.documentPath);
    else
      this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl('data:' + dmObj.attachedObj.documenttype + ';base64,' + dmObj.attachedObj.documentdata);
    const html = dmObj.directMsgObj.htmlText || dmObj.directMsgObj.TransformedXML;
    this.xmlContent = this.sanitizer.bypassSecurityTrustHtml(html || '');
    switch (dmObj.ispreview) {
      case 1:
        this.isPreview = true;
        break;
      case 2:
        this.isXMLPreview = true;
        break;
      case 3:
        this.isPreview = true;
        break;
      case 0:
        this.isDailogPreview = true;
    }

  }

  ngOnInit() {
    this.DirectMessageForm = this.fb.group({
      //msgPatName:[''],
      msgDocumentDate: [''],
      msgCurrentDate: [''],
      //msgDOB:[''],
      msgDocDestinationddl: [''],
      mgsLocation: [''],
      msgNote: [''],
      msgDocumentname: [''],
    });
    this.getAllDocCategoryList();
    this.getAllSubCategoryList();
    this.getLocations();
    this.DirectMessageForm.patchValue({
      msgDocumentDate: moment(new Date()).toDate(),
      msgCurrentDate: moment(new Date()).toDate()
    });
    this.DirectMessageForm.controls['msgDocumentname'].setValue(this.dmObj.attachedObj.documentName.split(".")[0]);
  }

  DocDestinationCategory: IDocument[];
  async getAllDocCategoryList() {
    this.docService.getAllDocCategory(0, Number(sessionStorage.getItem("FacilityId")), 1).subscribe(data => {
      this.DocDestinationCategory = data;
    });
  }

  DocDestinationSubCategory: IDocument[];
  async getAllSubCategoryList() {
    this.docService.getAllSubCategory().subscribe(data => {
      data = data.filter(i => i.subCategoryName != 'Patient identifications license');
      this.DocDestinationSubCategory = data;
    });
  }
  getDocDestinationSubCategory(docCategoryId: number, CategoryName: String) {
    if (docCategoryId == 0)
      return "";

    if (this.DocDestinationSubCategory) {
      if (CategoryName == 'FluoroImages' || CategoryName == 'FluoroReports') {
        return this.DocDestinationSubCategory.filter(i => i.docCategoryId == docCategoryId && i.subCategoryName == CategoryName)
      }
      else {
        var newsubcatlist: IDocument[] = []
        this.DocDestinationSubCategory.filter(i => i.docCategoryId == docCategoryId).forEach(x => {
          newsubcatlist.some(c => c.subCategoryName == x.subCategoryName) ? '' : newsubcatlist.push(x);
        });
        return newsubcatlist.sort((a, b) => a.subCategoryName.localeCompare(b.subCategoryName));
      }
    }
  }
  public lstLocations: ILocationDetails[];
  getLocations() {
    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true);
      this.DirectMessageForm.patchValue({
        mgsLocation: Number(sessionStorage.getItem("LocationId"))
      });
    });
  }
  createddate() {
    this.schedulerservice.getservercurrentdate().subscribe(async result => {
      await result;
      // // this.DirectMessageForm.patchValue({
      // //   msgCurrentDate : moment(result).toDate()
      // // });
    });
  }
  personalnumberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode < 47 || charCode > 57) {
      return false;
    }
    return true;
  }
  docCatId: number;
  subCatId: number;
  selectSubCat(subcatObj: any) {
    this.docCatId = subcatObj.docCategoryId;
    this.subCatId = subcatObj.subCategoryId;
  }
  AddDocDest() {

    //this.isShowDiv = !this.isShowDiv;

    const dialogRef = this.dialog.open(ManageCatgoriesComponent, {
      width: '1000px',
      height: '260px',
      data: null
    });

    dialogRef.afterClosed().subscribe(result => {

      let docmentInfo = result;
      // if (sessionStorage.getItem("FacilityId") != null || sessionStorage.getItem("FacilityId") != undefined || Number(sessionStorage.getItem("FacilityId")) > 0) {
      //   this.facilityId = parseInt(sessionStorage.getItem("FacilityId"));
      // }
      // let docmentInfo = result;
      // if (docmentInfo.extension !== '') {
      //   this.alllocation = this.facilityId;
      // } else {
      //   this.alllocation = 0;
      // }
      if (docmentInfo.subCategoryName === "") {
        this.SaveCategory(docmentInfo)
      } else {
        this.SaveSubCategory(docmentInfo);
      }
    });

  }

  dmPopup() {
    const dialogRef = this.dialog.open(SearchPatientDMPopupComponent);

    dialogRef.afterClosed().subscribe(result => {

      if (result != undefined && result != null) {
        this.patName = result.lastName + " " + result.firstName
        this.patDOB = result.dob
        this.patId = result.patientId;
      }
    });
  }
  SaveCategory(docmentInfo): void {
    let facId
    if (sessionStorage.getItem("FacilityId") != null || sessionStorage.getItem("FacilityId") != undefined || Number(sessionStorage.getItem("FacilityId")) > 0) {
      facId = parseInt(sessionStorage.getItem("FacilityId"));
    }
    this.docService.SaveDocCategory(docmentInfo, facId).subscribe((results: any) => {
      // this.result = results;
      this.toastr.success('Document Category Saved Successfully');
      this.getAllDocCategoryList();
    });
  }

  SaveSubCategory(docmentInfo): void {
    this.docService.SaveSubCategory(docmentInfo).subscribe((results: any) => {
      // this.result = results;
      this.toastr.success('Document Type Saved Successfully');
      this.getAllSubCategoryList();
    });
  }
  validateform() {
    try {
      if (!this.DirectMessageForm.controls['mgsLocation'].value) {
        this.toastr.error("Please select Location");
        return false
      }
      if (!Number(sessionStorage.getItem("FacilityId"))) {
        this.toastr.error("Invalid FacilityID ,Please Login again");
        return false
      }
      if ((!this.dmObj.attachedObj.documentName.split(".")[0]) || (!this.DirectMessageForm.controls['msgDocumentname'].value)) {
        this.toastr.error("Invalid Filename");
        return false
      }
      if (!this.DirectMessageForm.controls['msgDocumentDate'].value) {
        this.toastr.error("Invalid Document Date");
        return false
      }

      if (isNaN(Number(this.patId))) {
        this.toastr.error("Invalid PatientID");
        return false
      }

      if (!this.subCatId) {
        this.toastr.error("Invalid Document Type");
        return false

      }
      if (this.DirectMessageForm.controls['msgDocumentname'].value.trim() == "") {

        this.toastr.error("Invalid Document name");
        return false
      }
    }
    catch (ex) {

      this.toastr.error("Error : Invalid Data " + ex.toString());
      return false
    }
    return true;
  }
  onSubmit() {
    if (!this.validateform()) { return }
    const locid = this.DirectMessageForm.controls['mgsLocation'].value;
    const facid = Number(sessionStorage.getItem("FacilityId"));
    const docname = this.DirectMessageForm.controls['msgDocumentname'].value;
    const docdate = this.DirectMessageForm.controls['msgDocumentDate'].value;
    const docnotes = this.DirectMessageForm.controls['msgNote'].value;
    const Patid = Number(this.patId)

    const dmDocObj: Idocument_DIrectmsg = {
      locationId: locid,
      facilityId: facid,
      docCategoryId: this.docCatId,
      subCategoryId: this.subCatId,


      Notes: docnotes,
      //docFileURL: this.docUrl,
      //base64string: this.dmObj.attachedObj.documentdata,
      //DocumentType: 'Direct Messaging Documents',
      //Docpath: '',
      documentId: '0',
      documentName: docname,
      documentdate: docdate,

      patientId: Patid,
      subCategoryName: '',
      documentCategory: '',
      patFullName: '',
      patDOB: undefined,
      patGender: '',
      patAge: 0,
      extension: (this.dmObj.attachedObj.documentName.split(".")[1] ? this.dmObj.attachedObj.documentName.split(".")[1] : ''),
      encounterId: '',
      createdBy: sessionStorage.getItem('userId').toString(),

      fluoroscopeId: 0,
      count: 0,
      reportDocumentId: 0,

    }
    var base64string = dmDocObj.extension == "xml" ? this.dmObj.directMsgObj.TransformedXML : this.dmObj.attachedObj.documentdata;
    if (dmDocObj.extension != "xml")
      dmDocObj.extension = "pdf";
    this.uploadDirMsgPdf(dmDocObj, base64string);

    this.dialogRef.close();
  }
  onCancelClick() {
    this.dialogRef.close();
  }
  //   async  getpdfbase64(docDefinition,docresult)
  //   {

  //     const pdfDocGenerator = await pdfMake.createPdf(docDefinition);
  //   var document = await pdfDocGenerator.getStream().getDataUrl();

  // await this.uploadDirMsgPdf(docresult,document);
  //   }
  uploadDirMsgPdf(docresult: any, pdfFile: any) {
    this.docService.UploadDirectMsgDocument(docresult, pdfFile).subscribe(result => {
      this.toastr.success("Document Saved Successfully")
    });
  }
}
